import React, { useState } from "react";
import TitleSection from "../title-section";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import Button from "../../atoms/button/button";
import Slider from "react-slick";
import { Controller, useForm } from "react-hook-form";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import './RecomendationForm.scss'
import "../../organisms/courses-filter/coursesFilter.scss"; 

const RecomendationForm = (props:ReferenciaContenido) => {
    const CarouselProps = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.35,
                    dots:true,
                    slidesToScroll: 1
                }
            }
          ]
    };

    const { control, handleSubmit, watch } = useForm({
        defaultValues: { checkboxes: [] },
    });

    const selected: string[] = watch("checkboxes", []);
    const [isAnswerView, setIsAnswerView] = useState<boolean>(false);
    const [answerIndex, setAnswerIndex] = useState<number>(0);
    const blockName : string = "m-recomendation-form";

    const onSubmit = () => {
        setIsAnswerView(true);
        if (selected.length <= 2) {
            setAnswerIndex(0);
        } else if (selected.length == 3){
            setAnswerIndex(1);
        } else setAnswerIndex(2);
    };

    return(
        <div id="component-title">
            {!isAnswerView ?
                <section className={blockName}>
                    <div className={`${blockName}__header`}>
                        <TitleSection title={props.tituloGeneral} />
                        {props.descripcion && documentToReactComponents(props.descripcion.json)}
                    </div>
                    <form className={`${blockName}__form`} onSubmit={handleSubmit(onSubmit)}>
                        {props.referenciaFormulario && props.referenciaFormulario.map((question)=>{
                            return (
                                <>
                                    <label className={`${blockName}__card`}>
                                        <Controller
                                            name="checkboxes"
                                            control={control}
                                            render={({ field }) => (
                                            <input
                                                type="checkbox"
                                                value={question.contentful_id}
                                                className={`o-curses-filter__filter-option-radio ${blockName}__input`}
                                                checked={field.value.includes(question.contentful_id)}
                                                onChange={(e) => {
                                                const newValue = e.target.checked
                                                    ? [...field.value, e.target.value]
                                                    : field.value.filter((val) => val !== e.target.value);
                                                field.onChange(newValue);
                                                }}
                                            />
                                            )}
                                        />
                                        <p>{question.inputPrincipal}</p>
                                    </label>
                                </>
                            );
                        })}
                    </form>
                    {props.descripcionFija && contentfulRenderOptions(props.descripcionFija)}
                    <Button 
                        type="button"
                        text={"Ver resultado"}
                        classname={"dimensions"}
                        isDisabled={selected.length === 0}
                        onClickAction={onSubmit}
                    />
                </section>
            :
                <>
                    <section>
                        <div className={`${blockName}__header`}>
                            <TitleSection title="¿Te interesa migrar para desarrollarte laboralmente?" />
                        </div>
                        <div className={`${blockName}__banner`}>
                            <img className={`${blockName}__banner-img`} src={props.referenciaEventos[answerIndex].imagenPrincipal && props.referenciaEventos[answerIndex].imagenPrincipal?.file?.url}/>
                            <h3 className={`${blockName}__banner-title`}>{props.referenciaEventos[answerIndex].tituloEvento}</h3>
                            <p className={`${blockName}__banner-description`}> {props.referenciaEventos[answerIndex].textoIntroductorio}</p>
                            {props.referenciaEventos[answerIndex].tituloBoton && 
                                <Button 
                                    type="link"
                                    text={props.referenciaEventos[answerIndex].tituloBoton}
                                    classname={"dimensions-banner"}
                                    isDisabled={false}
                                    href={props.referenciaEventos[answerIndex].redireccionBoton}
                                />
                            }
                        </div>
                    </section>
                    {props.referenciaEventos[answerIndex].lugarEvento && 
                        <section>
                            <div className={`${blockName}__carousel-header`}>
                                <TitleSection title={props.referenciaEventos[answerIndex].lugarEvento} />
                            </div>
                            <div className={`${blockName}__carousel-slider`}>
                                <Slider {...CarouselProps}> 
                                    {props.referenciaPlantillaContenido.map((card) => {
                                        return(
                                            <div className={`${blockName}__carousel-card`}>
                                                <figure className={`${blockName}__carousel-figure`}>
                                                    <img src={card.imagenPrincipal[0].file.url} />
                                                </figure>
                                                <div className={`${blockName}__carousel-text`}>
                                                    <h4 className={`${blockName}__carousel-title`}>{card.tituloBanner}</h4>
                                                    {card.descripcion && documentToReactComponents(card.descripcion.json)}
                                                    <a className={`${blockName}__carousel-link`}>{card.tituloBoton}</a>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </section>
                    }
                </>
            }
        </div>
    );
};

export default RecomendationForm;
